import { Auth0Provider } from "@auth0/auth0-react";
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";

const container = document.getElementById("root");
const root = createRoot(container);

const domain = process.env.REACT_APP_AUTH0_DOMAIN;
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
const orgId = process.env.REACT_APP_ORGANIZATION_CODE;
const aud = process.env.REACT_APP_AUDIENCE;

root.render(
  <Auth0Provider
    domain={domain}
    useRefreshTokens
    cacheLocation="localstorage"
    clientId={clientId}
    authorizationParams={{
      redirect_uri: window.location.origin,
      organization: orgId,
      audience: aud,
      scope: "openid profile email offline_access",
    }}
  >
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Auth0Provider>
);
